<template>
  <div v-show="isOpen" ref="popup" class="fixed bg-white left-0 top-full w-full h-full z-50 overflow-x-clip overflow-y-auto">
    <div class="w-full h-0 text-right sticky top-0 right-0" style="z-index: 99;">
      <button @click="closePopup" class="absolute right-8 top-8 z-20">
        <svg width="19.269" height="19.269" viewBox="0 0 19.269 19.269">
          <g transform="translate(14787.656 4494.764)">
            <path d="M-14790.647-4472.538h25.249" transform="translate(-7490.944 9127.072) rotate(45)" fill="none" stroke="#00ef9a" stroke-width="2"/>
            <path d="M-14790.647-4472.538h25.249" transform="translate(-1165.82 -11772.208) rotate(-45)" fill="none" stroke="#00ef9a" stroke-width="2"/>
          </g>
        </svg>
      </button>
    </div>
    <div ref="header"></div>

    <div class="pt-14 flex relative">
      <div ref="page-left" class="w-screen absolute transition-all duration-500 pb-14" style="transition: transform 0.5s ease, opacity 0.5s ease">
        <article v-for="content in leftPageContents.content" :key="content.heading" class="container container--grid mb-14 last:mb-0 | md:mb-28">
          <h2 class="txt-h5 col-span-full mb-5 | sm:col-start-2 sm:col-span-4 | md:mb-0 md:col-start-1 md:col-span-5">
            {{ content.heading }}
          </h2>

          <div class="wysiwyg wysiwyg--link-green text-gray col-span-full | sm:col-start-2 sm:col-span-4 | md:col-start-7 md:col-span-5" v-html="content.content"></div>
        </article>
      </div>

      <div ref="page-right" class="w-screen absolute pb-14" style="transition: transform 0.5s ease, opacity 0.5s ease">
        <article v-for="content in rightPageContents.content" :key="content.heading" class="container container--grid mb-14 last:mb-0 | md:mb-28">
          <h2 class="txt-h5 col-span-full mb-5 | sm:col-start-2 sm:col-span-4 | md:mb-0 md:col-start-1 md:col-span-5">
            {{ content.heading }}
          </h2>

          <div class="wysiwyg wysiwyg--link-green text-gray col-span-full | sm:col-start-2 sm:col-span-4 | md:col-start-7 md:col-span-5" v-html="content.content"
          ></div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "footer-popup",
  props: ["left-page", "right-page"],
  data() {
    return {
      isOpen: false,
      currentTab: null,
      currentTabContent: [],
      leftPageContents: JSON.parse(this.leftPage),
      rightPageContents: JSON.parse(this.rightPage),
    };
  },
  methods: {
    getFooter() {
      const footer = document.querySelector(".footer");
      const clone = footer.cloneNode(true);
      this.$refs.header.appendChild(clone);

      this.$refs.header
        .querySelector(".c-logo-static")
        .classList.remove("invisible");
      this.$refs.header.querySelector(".c-logo-container").remove();

      footer.querySelectorAll("[data-popup-tab]").forEach((btn) => {
        btn.addEventListener("click", () => {
          this.openTab(btn.dataset.popupTab);
          this.openPopup();
        });
      });

      const buttons = this.$refs.header.querySelectorAll(
        ".footer [data-popup-tab]"
      );
      buttons.forEach((btn) => {
        btn.addEventListener("click", () => {
          this.openTab(btn.dataset.popupTab);
        });
      });
    },
    openTab(id) {
      this.currentTab = id;

      if (this.leftPageContents.id === id) {
        this.$refs["page-left"].style.display = "block";

        window.setTimeout(() => {
          this.$refs.header.classList.add("pointer-events-none");
          this.$refs["page-left"].style.transform = "translate3d(0, 0, 0)";
          this.$refs["page-left"].style.opacity = "1";

          this.$refs["page-right"].style.transform = "translate3d(100%, 0, 0)";
          this.$refs["page-right"].style.opacity = "0";

          window.setTimeout(() => {
            this.$refs["page-right"].style.display = "none";
            this.$refs.header.classList.remove("pointer-events-none");
          }, 550);
        }, 10);
      } else if (this.rightPageContents.id === id) {
        this.$refs["page-right"].style.display = "block";

        window.setTimeout(() => {
          this.$refs.header.classList.add("pointer-events-none");
          this.$refs["page-left"].style.transform = "translate3d(-100%, 0, 0)";
          this.$refs["page-left"].style.opacity = "0";

          this.$refs["page-right"].style.transform = "translate3d(0, 0, 0)";
          this.$refs["page-right"].style.opacity = "1";

          window.setTimeout(() => {
            this.$refs["page-left"].style.display = "none";
            this.$refs.header.classList.remove("pointer-events-none");
          }, 550);
        }, 10);
      }

      const buttons = this.$refs.header.querySelectorAll(
        ".footer [data-popup-tab]"
      );
      buttons.forEach((btn) => {
        if (btn.dataset.popupTab !== this.currentTab) {
          btn.classList.add("text-opacity-50");
        } else {
          btn.classList.remove("text-opacity-50");
        }
      });
    },
    openPopup() {
      document.body.classList.add("overflow-hidden");
      this.isOpen = true;
      this.$refs.popup.classList.add("fade-up");
    },
    closePopup() {
      this.$refs.popup.classList.remove("fade-up");
      this.$refs.popup.classList.add("fade-down");

      window.setTimeout(() => {
        this.$refs.popup.classList.remove("fade-down");
        this.isOpen = false;
        document.body.classList.remove("overflow-hidden");
      }, 510);
    },
  },
  mounted() {
    this.getFooter();
  },
};
</script>

<style scoped lang="scss">
.wysiwyg p {
  strong,
  b {
    color: #000;
  }
}

.fade-up {
  animation: open 0.3s ease both;
}

.fade-down {
  animation: close 0.3s ease both;
}

@keyframes open {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-100%);
  }
}

@keyframes close {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}
</style>